/*
	SleepPeople — Sepet v3 davranışları (çekmece + /cart sayfası).

	Çekmece ve sayfa her sepet güncellemesinde innerHTML olarak yeniden yazıldığı için
	(app.js → CartDrawer, cart.js → Cart) tüm dinleyiciler document üzerinde
	delege edilmiştir; tarih gibi yazılar her yeniden çizimde MutationObserver ile
	tekrar doldurulur.

	1. Öneri kartı varyant dropdown'ı + sayfadaki öneri kartından sepete ekleme
	2. Ürün çıkarma onayı
	3. Sepetteki ürünün ölçüsünü / seçeneğini değiştirme
	4. Tahmini teslim tarihi
	5. Otomatik dönen müşteri yorumları
	6. Sipariş notunu otomatik kaydetme
	7. Ödeme butonu yükleniyor durumu + Clarity olayları
*/
(function () {
	'use strict';

	function track(name) {
		try {
			if (typeof window.clarity === 'function') {
				window.clarity('event', name);
			}
		} catch (e) { /* yoksay */ }
	}

	function routes() {
		return (window.theme && window.theme.routes) || {};
	}

	function postJSON(url, body) {
		return fetch(url, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
			body: JSON.stringify(body)
		}).then(function (response) {
			return response.json().then(function (data) {
				if (!response.ok || data.status) {
					throw new Error(data.description || data.message || 'Sepet güncellenemedi');
				}
				return data;
			});
		});
	}

	// Çekmeceyi ve /cart sayfasını birlikte yeniler (ikisi de 'cart:refresh' dinler).
	function refreshCart() {
		document.dispatchEvent(new CustomEvent('cart:refresh'));
	}

	/* ---------- 1. Öneri kartları ---------- */
	function priceMarkup(price, compare) {
		if (compare) {
			return '<span class="price"><del><span class="amount">' + compare + '</span></del>' +
				'<ins><span class="amount">' + price + '</span></ins></span>';
		}
		return '<span class="price"><ins><span class="amount">' + price + '</span></ins></span>';
	}

	document.addEventListener('change', function (event) {
		var select = event.target;
		if (!select || !select.classList || !select.classList.contains('cart-rec-card--select')) {
			return;
		}
		var card = select.closest('product-card-small, [data-spc-rec]');
		var option = select.options[select.selectedIndex];
		if (!card || !option) {
			return;
		}
		// ProductCardSmall varyant id'sini elemanın `id` özelliğinden okur.
		if (card.tagName.toLowerCase() === 'product-card-small') {
			card.id = select.value;
		}
		card.dataset.id = select.value;

		var priceEl = card.querySelector('.cart-rec-card--price');
		if (priceEl && option.dataset.price) {
			priceEl.innerHTML = priceMarkup(option.dataset.price, option.dataset.compare);
		}
	});

	/* ---------- 3. Sepetteki ürünün seçeneğini değiştirme ---------- */
	function readJSON(text, fallback) {
		try {
			return JSON.parse(text);
		} catch (e) {
			return fallback;
		}
	}

	document.addEventListener('change', function (event) {
		var select = event.target;
		if (!select || !select.matches || !select.matches('[data-spc-option]')) {
			return;
		}
		var wrap = select.closest('[data-spc-variant]');
		if (!wrap) {
			return;
		}
		var item = wrap.closest('.spc-item');
		var msg = wrap.querySelector('[data-spc-variant-msg]');
		var current = readJSON(wrap.dataset.current, []);
		var variantsEl = wrap.querySelector('[data-spc-variants]');
		var variants = readJSON(variantsEl ? variantsEl.textContent : '[]', []);

		var wanted = current.slice();
		wrap.querySelectorAll('[data-spc-option]').forEach(function (el) {
			wanted[parseInt(el.dataset.spcOption, 10)] = el.value;
		});

		function showMessage(text) {
			if (msg) {
				msg.textContent = text;
				msg.hidden = !text;
			}
		}

		function revert() {
			wrap.querySelectorAll('[data-spc-option]').forEach(function (el) {
				el.value = current[parseInt(el.dataset.spcOption, 10)];
			});
		}

		var match = variants.filter(function (v) {
			return v.options.every(function (value, i) { return value === wanted[i]; });
		})[0];

		if (!match || !match.available) {
			revert();
			showMessage('Bu seçenek şu an stokta yok.');
			return;
		}
		if (String(match.id) === wrap.dataset.variantId) {
			showMessage('');
			return;
		}

		showMessage('');
		if (item) {
			item.classList.add('thb-loading', 'loading');
		}

		var line = {
			id: match.id,
			quantity: parseInt(wrap.dataset.qty, 10) || 1
		};
		// Liquid boş properties'i [] olarak basar; /cart/add.js ise nesne ister
		// ("expected Array to be a Hash: properties"). Sadece dolu nesneyi gönder.
		var properties = readJSON(wrap.dataset.properties, null);
		if (properties && !Array.isArray(properties) && typeof properties === 'object') {
			var cleanProps = {};
			Object.keys(properties).forEach(function (key) {
				if (properties[key] !== null && properties[key] !== '') {
					cleanProps[key] = properties[key];
				}
			});
			if (Object.keys(cleanProps).length) {
				line.properties = cleanProps;
			}
		}
		if (wrap.dataset.sellingPlan) {
			line.selling_plan = wrap.dataset.sellingPlan;
		}

		var oldVariantId = parseInt(wrap.dataset.variantId, 10);
		var oldLine = {
			id: oldVariantId,
			quantity: line.quantity
		};
		if (line.properties) {
			oldLine.properties = line.properties;
		}
		if (line.selling_plan) {
			oldLine.selling_plan = line.selling_plan;
		}

		// Sepetteki satırı güncel sepetten bul: satır anahtarı sepet değiştikçe
		// yenilenebildiği için önce anahtarla, olmazsa varyant id ile eşleştir.
		function findLineNumber(cart) {
			var items = (cart && cart.items) || [];
			for (var i = 0; i < items.length; i++) {
				if (items[i].key === wrap.dataset.key) {
					return i + 1;
				}
			}
			for (var j = 0; j < items.length; j++) {
				if (items[j].variant_id === oldVariantId) {
					return j + 1;
				}
			}
			return 0;
		}

		// 1) Eski ölçüyü çıkar  2) yeni ölçüyü ekle  3) ekleme olmazsa eskisini geri koy.
		var removed = false;
		fetch(routes().cart_url + '.js', { headers: { 'Accept': 'application/json' } })
			.then(function (response) { return response.json(); })
			.then(function (cart) {
				var lineNumber = findLineNumber(cart);
				if (!lineNumber) {
					throw new Error('Ürün sepette bulunamadı, sayfayı yenileyin.');
				}
				return postJSON(routes().cart_change_url + '.js', { line: lineNumber, quantity: 0 });
			})
			.then(function () {
				removed = true;
				return postJSON(routes().cart_add_url + '.js', { items: [line] });
			})
			.then(function () {
				track('cart_variant_changed');
				refreshCart();
			})
			.catch(function (error) {
				var restore = removed
					? postJSON(routes().cart_add_url + '.js', { items: [oldLine] }).catch(function () {})
					: Promise.resolve();
				restore.then(function () {
					revert();
					showMessage(error.message);
					if (item) {
						item.classList.remove('thb-loading', 'loading');
					}
					refreshCart();
				});
			});
	});

	/* ---------- 2. Ürün çıkarma onayı (+ sayfadaki öneriden ekleme) ---------- */
	document.addEventListener('click', function (event) {
		var target = event.target;
		if (!target || !target.closest) {
			return;
		}

		var trash = target.closest('[data-spc-remove]');
		if (trash) {
			event.preventDefault();
			var item = trash.closest('.spc-item');
			var confirmBox = item && item.querySelector('[data-spc-confirm]');
			if (confirmBox) {
				confirmBox.hidden = false;
				var cancel = confirmBox.querySelector('[data-spc-remove-cancel]');
				if (cancel) {
					cancel.focus();
				}
				track('cart_remove_intent');
			}
			return;
		}

		var cancelBtn = target.closest('[data-spc-remove-cancel]');
		if (cancelBtn) {
			event.preventDefault();
			var box = cancelBtn.closest('[data-spc-confirm]');
			if (box) {
				box.hidden = true;
				var trashBtn = box.parentNode.querySelector('[data-spc-remove]');
				if (trashBtn) {
					trashBtn.focus();
				}
			}
			track('cart_remove_cancelled');
			return;
		}

		// Silme tamamen burada yapılır. Tema cart.js'i .remove dinleyicisini her yeniden
		// çizimde yeniden bağlıyor (renderContents içindeki döngüde), bu yüzden tek tıklama
		// iki istek gönderiyor ve ikincisi kayan satır numarası yüzünden başka ürünü siliyordu.
		// Satır numarası yerine satır anahtarı (key) gönderiliyor.
		var yes = target.closest('[data-spc-remove-yes]');
		if (yes) {
			event.preventDefault();
			if (yes.dataset.busy) {
				return;
			}
			yes.dataset.busy = '1';
			var yesBox = yes.closest('[data-spc-confirm]');
			if (yesBox) {
				yesBox.hidden = true;
			}
			var yesItem = yes.closest('.spc-item');
			if (yesItem) {
				yesItem.classList.add('thb-loading', 'loading');
			}
			track('cart_remove_confirmed');
			var removeLine = yes.dataset.key || parseInt(yes.dataset.index, 10);
			postJSON(routes().cart_change_url + '.js', { id: removeLine, quantity: 0 })
				.then(function () {
					refreshCart();
				})
				.catch(function (error) {
					delete yes.dataset.busy;
					if (yesItem) {
						yesItem.classList.remove('thb-loading', 'loading');
					}
					window.alert(error.message);
				});
			return;
		}

		var recAdd = target.closest('[data-spc-rec-add]');
		if (recAdd) {
			event.preventDefault();
			var card = recAdd.closest('[data-spc-rec]');
			if (!card || recAdd.classList.contains('loading')) {
				return;
			}
			recAdd.classList.add('loading');
			postJSON(routes().cart_add_url + '.js', { items: [{ id: card.dataset.id, quantity: 1 }] })
				.then(function () {
					track('cart_rec_added');
					refreshCart();
				})
				.catch(function (error) {
					recAdd.classList.remove('loading');
					window.alert(error.message);
				});
			return;
		}

		var tracked = target.closest('[data-spc-track]');
		if (tracked) {
			track(tracked.dataset.spcTrack);
		}
	});

	document.addEventListener('keyup', function (event) {
		if (event.key !== 'Escape') {
			return;
		}
		document.querySelectorAll('[data-spc-confirm]:not([hidden])').forEach(function (box) {
			box.hidden = true;
		});
	});

	// /cart sayfasında adet değişince çekmece de güncel kalsın (ya da tersi).
	document.addEventListener('line-item:change:end', function () {
		if (document.getElementById('Cart') && document.getElementById('Cart-Drawer')) {
			refreshCart();
		}
	});

	/* ---------- 4. Tahmini teslim tarihi ---------- */
	var MONTHS = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

	function isBusinessDay(date) {
		var d = date.getDay();
		return d !== 0 && d !== 6;
	}

	function addBusinessDays(start, count) {
		var date = new Date(start.getTime());
		var added = 0;
		while (added < count) {
			date.setDate(date.getDate() + 1);
			if (isBusinessDay(date)) {
				added++;
			}
		}
		return date;
	}

	function formatRange(from, to) {
		if (from.getMonth() === to.getMonth()) {
			return from.getDate() + '–' + to.getDate() + ' ' + MONTHS[to.getMonth()];
		}
		return from.getDate() + ' ' + MONTHS[from.getMonth()] + ' – ' + to.getDate() + ' ' + MONTHS[to.getMonth()];
	}

	function renderDelivery() {
		document.querySelectorAll('[data-spc-delivery]').forEach(function (el) {
			var min = parseInt(el.dataset.min, 10) || 2;
			var max = parseInt(el.dataset.max, 10) || Math.max(min, 5);
			var cutoff = parseInt(el.dataset.cutoff, 10);
			if (isNaN(cutoff)) {
				cutoff = 14;
			}

			var now = new Date();
			// Kesim saati geçtiyse ya da hafta sonuysa sayım bir sonraki iş gününden başlar.
			var base = new Date(now.getTime());
			if (!(isBusinessDay(now) && now.getHours() < cutoff)) {
				base = addBusinessDays(base, 1);
			}

			var text = 'Tahmini teslimat: <b>' + formatRange(addBusinessDays(base, min), addBusinessDays(base, max)) + '</b>';
			if (el.innerHTML !== text) {
				el.innerHTML = text;
			}
		});
	}

	/* ---------- 5. Müşteri yorumları ---------- */
	var REVIEW_INTERVAL = 5000;
	var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	function reviewIndex(track) {
		var slides = track.children;
		if (slides.length < 2) {
			return 0;
		}
		// Kaydırma adımı = kart genişliği + aradaki boşluk (track position: relative).
		var step = slides[1].offsetLeft - slides[0].offsetLeft;
		return step > 0 ? Math.round(track.scrollLeft / step) : 0;
	}

	function goToReview(track, index) {
		var slides = track.children;
		if (!slides.length) {
			return;
		}
		var i = (index + slides.length) % slides.length;
		track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: reducedMotion ? 'auto' : 'smooth' });
		var root = track.closest('[data-spc-reviews]');
		if (root) {
			root.querySelectorAll('[data-spc-review-dot]').forEach(function (dot, n) {
				dot.setAttribute('aria-current', n === i ? 'true' : 'false');
			});
		}
	}

	function updateDots(root) {
		var track = root.querySelector('[data-spc-reviews-track]');
		var dots = root.querySelectorAll('[data-spc-review-dot]');
		var current = reviewIndex(track);
		dots.forEach(function (dot, i) {
			dot.setAttribute('aria-current', i === current ? 'true' : 'false');
		});
	}

	function setupReviews() {
		document.querySelectorAll('[data-spc-reviews]').forEach(function (root) {
			if (root.dataset.ready) {
				return;
			}
			root.dataset.ready = '1';
			var track = root.querySelector('[data-spc-reviews-track]');
			var dotsWrap = root.querySelector('[data-spc-reviews-dots]');
			if (!track || !dotsWrap) {
				return;
			}
			var count = track.children.length;
			if (count < 2) {
				return;
			}
			for (var i = 0; i < count; i++) {
				var dot = document.createElement('button');
				dot.type = 'button';
				dot.className = 'spc-reviews__dot';
				dot.setAttribute('data-spc-review-dot', i);
				dot.setAttribute('aria-label', (i + 1) + '. yorum');
				dotsWrap.appendChild(dot);
			}
			updateDots(root);

			var scrollTimer;
			track.addEventListener('scroll', function () {
				clearTimeout(scrollTimer);
				scrollTimer = setTimeout(function () { updateDots(root); }, 80);
			}, { passive: true });

			function pause() { root.dataset.paused = '1'; }
			function resume() { delete root.dataset.paused; }
			root.addEventListener('mouseenter', pause);
			root.addEventListener('mouseleave', resume);
			root.addEventListener('focusin', pause);
			root.addEventListener('focusout', resume);
			root.addEventListener('touchstart', pause, { passive: true });
			root.addEventListener('touchend', function () {
				setTimeout(resume, REVIEW_INTERVAL);
			}, { passive: true });

			dotsWrap.addEventListener('click', function (event) {
				var dotBtn = event.target.closest('[data-spc-review-dot]');
				if (dotBtn) {
					goToReview(track, parseInt(dotBtn.getAttribute('data-spc-review-dot'), 10));
				}
			});
		});
	}

	function autoplayReviews() {
		if (reducedMotion || document.hidden) {
			return;
		}
		document.querySelectorAll('[data-spc-reviews]').forEach(function (root) {
			// Görünmüyorsa (çekmece kapalı) ya da kullanıcı etkileşimdeyse kaydırma.
			if (root.dataset.paused || !root.offsetParent) {
				return;
			}
			var track = root.querySelector('[data-spc-reviews-track]');
			if (track && track.children.length > 1) {
				goToReview(track, reviewIndex(track) + 1);
			}
		});
	}

	/* ---------- 6. Sipariş notu ---------- */
	var noteTimer;
	document.addEventListener('input', function (event) {
		var field = event.target;
		if (!field || !field.matches || !field.matches('[data-spc-note]')) {
			return;
		}
		var status = field.parentNode.querySelector('[data-spc-note-status]');
		clearTimeout(noteTimer);
		noteTimer = setTimeout(function () {
			fetch(routes().cart_update_url + '.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
				body: JSON.stringify({ note: field.value })
			}).then(function () {
				if (status) {
					status.textContent = 'Not kaydedildi';
				}
			});
		}, 600);
	});

	/* ---------- 7. Ödeme butonu ---------- */
	document.addEventListener('submit', function (event) {
		var form = event.target;
		if (!form || !form.matches || !form.matches('[data-spc-checkout-form]')) {
			return;
		}
		var button = form.querySelector('.spc-cta');
		if (button) {
			button.classList.add('is-loading');
			// Geri tuşuyla dönüldüğünde (bfcache) buton kilitli kalmasın.
			setTimeout(function () { button.classList.remove('is-loading'); }, 6000);
		}
		track('cart_checkout_click');
	});

	/* ---------- Yeniden çizimleri izle ---------- */
	function onRender() {
		renderDelivery();
		setupReviews();
	}

	function init() {
		onRender();
		if ('MutationObserver' in window) {
			['Cart-Drawer', 'Cart'].forEach(function (id) {
				var el = document.getElementById(id);
				if (el) {
					new MutationObserver(onRender).observe(el, { childList: true, subtree: true });
				}
			});
		}
		document.addEventListener('cart-drawer:open', function () {
			onRender();
			track('cart_drawer_open');
		});
		setInterval(renderDelivery, 60000);
		setInterval(autoplayReviews, REVIEW_INTERVAL);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
